/* PLASTIVER · Link corto de cotización (PVQ). La cotización viaja empacada en bytes después del «#»:
   plastiverr.com/c#… (v3, unos 70–85 caracteres). Abre también los formatos anteriores (#q= y v2). Código propio. */
(function () {
  if (window.PVQ) return;
  /* No cambiar el orden de estas listas (los links ya enviados dependen de él); agregar al final. */
  var ASES = ['Luis', 'Fernando', 'María Fernanda', 'Bibiana'], CALS = [300, 400, 500, 600], PERF = [0, 2, 4];
  var T6 = ' abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZáéíóúñÑ.-,';
  var F32 = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  var S = null, SP = null;
  function envio() {
    if (window.PVEnvio) return Promise.resolve(window.PVEnvio);
    return new Promise(function (r) { if (document.readyState === 'complete') r(window.PVEnvio); else window.addEventListener('load', function () { r(window.PVEnvio); }); });
  }
  function ready() {
    if (S) return Promise.resolve(S);
    if (!SP) SP = envio().then(function (E) { return E && E.sucursales ? E.sucursales() : []; }).then(function (s) { S = s || []; return S; }, function () { S = []; return S; });
    return SP;
  }
  function isArr(v) { return Object.prototype.toString.call(v) === '[object Array]'; }
  function h16(s) { var x = 2166136261; for (var i = 0; i < s.length; i++) { x ^= s.charCodeAt(i); x = Math.imul(x, 16777619) >>> 0; } return (x ^ (x >>> 16)) & 65535; }
  function sucName(x) { return x[2] + ' — ' + x[3]; }
  function sucRef(s) {
    if (!S || !S.length) return null;
    for (var i = 0; i < S.length; i++) {
      if (sucName(S[i]) !== s) continue;
      var h = h16(s), n = 0; for (var j = 0; j < S.length; j++) if (h16(sucName(S[j])) === h) n++;
      if (n === 1) return { h: h };
      var x = S[i]; if (!/^\d{5}$/.test(x[1])) return null;
      var k = 0; for (j = 0; j < i; j++) if (S[j][1] === x[1]) k++;
      return k < 256 ? { cp: +x[1], k: k } : null;
    }
    return null;
  }
  function sucTxt(r) {
    var hits;
    if (r.h != null) { hits = (S || []).filter(function (x) { return h16(sucName(x)) === r.h; }); return hits.length === 1 ? sucName(hits[0]) : 'Sucursal Tresguerras'; }
    var cp = ('0000' + r.cp).slice(-5); hits = (S || []).filter(function (x) { return x[1] === cp; });
    return hits[r.k] ? sucName(hits[r.k]) : 'Sucursal Tresguerras CP ' + cp;
  }
  function dias(n) { /* aaaammdd → días desde 2020-01-01 (o -1 si no es fecha) */
    if (typeof n !== 'number' || n % 1 || n < 20200101 || n > 21001231) return -1;
    var y = Math.floor(n / 10000), m = Math.floor(n / 100) % 100, d = n % 100, t = Date.UTC(y, m - 1, d), D = new Date(t);
    if (D.getUTCFullYear() !== y || D.getUTCMonth() !== m - 1 || D.getUTCDate() !== d) return -1;
    return Math.round((t - Date.UTC(2020, 0, 1)) / 864e5);
  }
  function fecha(k) { var D = new Date(Date.UTC(2020, 0, 1) + k * 864e5); return D.getUTCFullYear() * 10000 + (D.getUTCMonth() + 1) * 100 + D.getUTCDate(); }

  /* ---------- escritura ---------- */
  function W() { this.o = []; }
  W.prototype.vi = function (n) { var o = this.o; while (n > 127) { o.push((n % 128) + 128); n = Math.floor(n / 128); } o.push(n); };
  W.prototype.raw = function (s) { for (var i = 0; i < s.length; i++) this.o.push(s.charCodeAt(i) & 255); };
  W.prototype.str = function (s) {
    s = String(s); var u = unescape(encodeURIComponent(s)), bits = 0, ok = !/[\uD800-\uDFFF]/.test(s), i;
    if (ok) for (i = 0; i < s.length; i++) bits += T6.indexOf(s[i]) >= 0 ? 6 : 22;
    if (ok && Math.ceil(bits / 8) < u.length) {
      this.vi(s.length * 2 + 1); var acc = [], self = this;
      var put = function (v, n) { for (var b = n - 1; b >= 0; b--) acc.push((v >> b) & 1); };
      for (i = 0; i < s.length; i++) { var p = T6.indexOf(s[i]); if (p >= 0) put(p, 6); else { put(63, 6); put(s.charCodeAt(i), 16); } }
      while (acc.length % 8) acc.push(0);
      for (i = 0; i < acc.length; i += 8) { var by = 0; for (var j = 0; j < 8; j++) by = by * 2 + acc[i + j]; self.o.push(by); }
    } else { this.vi(u.length * 2); this.raw(u); }
  };
  W.prototype.val = function (v) { /* valor genérico (campos raros) */
    var o = this.o, a;
    if (v === null || v === undefined) return o.push(0x47);
    if (v === true) return o.push(0x45);
    if (v === false) return o.push(0x46);
    if (typeof v === 'number') {
      if (isFinite(v) && v % 1 === 0 && Math.abs(v) <= 9e15) { if (v >= 0 && v < 64) return o.push(v); o.push(v < 0 ? 0x41 : 0x40); return this.vi(Math.abs(v)); }
      var c = Math.round(v * 100);
      if (isFinite(v) && Math.abs(c - v * 100) < 1e-6 && Math.abs(c) <= 9e15) { o.push(c < 0 ? 0x4B : 0x42); return this.vi(Math.abs(c)); }
      o.push(0x4C); return this.str(String(v));
    }
    if (isArr(v)) { o.push(0x44); this.vi(v.length); for (a = 0; a < v.length; a++) this.val(v[a]); return; }
    o.push(0x43); this.str(v);
  };
  function linea(l) {
    return isArr(l) && l.length === 7 && [0, 1].every(function (i) { return typeof l[i] === 'number' && l[i] >= 0 && l[i] <= 127.5 && (l[i] * 2) % 1 === 0; })
      && CALS.indexOf(l[2]) >= 0 && PERF.indexOf(l[3]) >= 0 && (l[4] === 0 || l[4] === 1) && (l[5] === 0 || l[5] === 1)
      && typeof l[6] === 'number' && l[6] % 1 === 0 && l[6] >= 0 && l[6] < 1e9;
  }
  function pack(Q) {
    var w = new W(), m = 0, i;
    var folio = Q[0] == null ? '' : String(Q[0]), f32 = /^[A-HJ-NP-Z2-9]{6}$/.test(folio);
    var cli = Q[1] ? String(Q[1]) : '', ase = Q[2] ? String(Q[2]) : '', cp = Q[4] == null ? '' : String(Q[4]);
    var envM = +Q[8] || 0, envTxt = typeof Q[10] === 'string' ? Q[10] : '', d = dias(Q[13]);
    if (f32) m |= 1; if (cli) m |= 2; if (ase) m |= 4; if (cp) m |= 8; if (envM) m |= 16; if (envTxt) m |= 32; if (d >= 0) m |= 64; if (+Q[15]) m |= 128;
    if (Q[3]) m |= 256; if (+Q[9]) m |= 512; if (+Q[5]) m |= 1024; if (Q[6] && Q[6] !== 'i') m |= 2048; if (Q[7]) m |= 4096; if (Q[12]) m |= 8192; if (Q[14]) m |= 16384; if (d < 0 && Q[13]) m |= 32768;
    w.o.push(3); w.vi(m);
    if (f32) { var n = 0; for (i = 0; i < 6; i++) n = n * 32 + F32.indexOf(folio[i]); w.o.push((n >>> 24) & 255, (n >>> 16) & 255, (n >>> 8) & 255, n & 255); } else w.str(folio);
    if (cli) w.str(cli);
    if (ase) { i = ASES.indexOf(ase); if (i >= 0) w.vi(i * 2); else { w.vi(1); w.str(ase); } }
    if (cp) { if (/^\d{5}$/.test(cp)) w.vi(+cp * 2); else { w.vi(1); w.str(cp); } }
    if (envM) w.val(envM);
    if (envTxt) { var r = envTxt.indexOf(' — ') > 0 ? sucRef(envTxt) : null; if (r && r.h != null) { w.vi(0); w.o.push(r.h >> 8, r.h & 255); } else if (r) { w.vi(1); w.vi(r.cp); w.o.push(r.k); } else { w.vi(2); w.str(envTxt); } }
    if (d >= 0) w.vi(d);
    if (m & 512) w.val(+Q[9]);
    if (m & 1024) w.val(+Q[5]);
    if (m & 2048) w.str(Q[6]);
    if (m & 4096) w.val(Q[7]);
    if (m & 8192) w.str(Q[12]);
    if (m & 16384) w.str(Q[14]);
    if (m & 32768) w.val(Q[13]);
    var L = isArr(Q[11]) ? Q[11] : []; w.vi(L.length);
    L.forEach(function (l) {
      if (linea(l)) { w.o.push(CALS.indexOf(l[2]) | (PERF.indexOf(l[3]) << 2) | (l[4] << 4) | (l[5] << 5), l[0] * 2, l[1] * 2); w.vi(l[6]); }
      else { w.o.push(0x80); w.val(l); }
    });
    var bin = ''; for (i = 0; i < w.o.length; i++) bin += String.fromCharCode(w.o[i]);
    return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  /* ---------- lectura (v2 y v3) ---------- */
  function unpack(t) {
    try {
      t = String(t).replace(/-/g, '+').replace(/_/g, '/'); while (t.length % 4) t += '=';
      var b = atob(t), p = 0;
      var u8 = function () { if (p >= b.length) throw 0; return b.charCodeAt(p++); };
      var vi = function () { var n = 0, m = 1, c; do { c = u8(); n += (c & 127) * m; m *= 128; } while (c & 128); return n; };
      var utf = function (n) { if (p + n > b.length) throw 0; var s = b.substr(p, n); p += n; return decodeURIComponent(escape(s)); };
      var str = function () {
        var h = vi(), n = Math.floor(h / 2);
        if (!(h & 1)) return utf(n);
        var bit = 0, cur = 0, rd = function (k) { var v = 0; while (k--) { if (bit === 0) { cur = u8(); bit = 8; } bit--; v = v * 2 + ((cur >> bit) & 1); } return v; }, s = '';
        while (n--) { var c = rd(6); s += c === 63 ? String.fromCharCode(rd(16)) : T6.charAt(c); if (c !== 63 && c >= T6.length) throw 0; }
        return s;
      };
      var val = function () {
        var c = u8(), n, a;
        if (c < 64) return c;
        if (c >= 0x80 && c < 0xC0) return utf(c - 0x80);
        if (c >= 0xC0 && c < 0xD0) { n = c - 0xC0; a = []; while (n--) a.push(val()); return a; }
        switch (c) {
          case 0x40: return vi();
          case 0x41: return -vi();
          case 0x42: return vi() / 100;
          case 0x4B: return -vi() / 100;
          case 0x43: return ver === 2 ? utf(vi()) : str();
          case 0x44: n = vi(); a = []; while (n--) a.push(val()); return a;
          case 0x45: return true;
          case 0x46: return false;
          case 0x47: return null;
          case 0x48: n = vi(); return { pvsuc: { cp: n, k: u8() } };
          case 0x49: return String(vi());
          case 0x4C: return ver === 2 ? +utf(vi()) : +str();
        }
        throw 0;
      };
      var ver = u8(), Q;
      if (ver === 2) Q = val();
      else if (ver === 3) {
        var m = vi(), x, i;
        Q = ['', '', '', 0, '', 0, 'i', 0, 0, 0, '', [], '', '', '', 0];
        if (m & 1) { x = ((u8() << 24) >>> 0) + (u8() << 16) + (u8() << 8) + u8(); var f = ''; for (i = 0; i < 6; i++) { f = F32.charAt(x % 32) + f; x = Math.floor(x / 32); } Q[0] = f; } else Q[0] = str();
        if (m & 2) Q[1] = str();
        if (m & 4) { x = vi(); Q[2] = x & 1 ? str() : (ASES[x / 2] || ''); }
        if (m & 8) { x = vi(); Q[4] = x & 1 ? str() : ('0000' + x / 2).slice(-5); }
        if (m & 16) Q[8] = val();
        if (m & 32) { x = vi(); Q[10] = x === 0 ? { pvsuc: { h: (u8() << 8) + u8() } } : x === 1 ? { pvsuc: { cp: vi(), k: u8() } } : str(); }
        if (m & 64) Q[13] = fecha(vi());
        if (m & 128) Q[15] = 1;
        if (m & 256) Q[3] = 1;
        if (m & 512) Q[9] = val();
        if (m & 1024) Q[5] = val();
        if (m & 2048) Q[6] = str();
        if (m & 4096) Q[7] = val();
        if (m & 8192) Q[12] = str();
        if (m & 16384) Q[14] = str();
        if (m & 32768) Q[13] = val();
        var n = vi(), L = [];
        while (n--) { var fl = u8(); if (fl & 0x80) L.push(val()); else { var a2 = u8(), l2 = u8(); L.push([a2 / 2, l2 / 2, CALS[fl & 3], PERF[(fl >> 2) & 3], (fl >> 4) & 1, (fl >> 5) & 1, vi()]); if (PERF[(fl >> 2) & 3] === undefined) throw 0; } }
        Q[11] = L;
      } else return null;
      return p === b.length ? Q : null;
    } catch (e) { return null; }
  }
  function esRef(v) { return !!(v && typeof v === 'object' && !isArr(v) && v.pvsuc); }
  function any(v) { return isArr(v) ? v.some(any) : esRef(v); }
  function fill(v) { return isArr(v) ? v.map(fill) : esRef(v) ? sucTxt(isArr(v.pvsuc) ? { cp: v.pvsuc[0], k: v.pvsuc[1] } : v.pvsuc) : v; }
  function resolve(Q) { return any(Q) ? ready().then(function () { return fill(Q); }) : Promise.resolve(Q); }
  window.PVQ = { pack: pack, unpack: unpack, ready: ready, resolve: resolve, any: any };
  if (window.PVEnvio) ready();
})();

/* PLASTIVER · El carrito genera su cotización: el mismo link que arma el equipo en /pages/armar-pedido,
   con lo que el cliente eligió (medidas, bultos, factura, CP y envío). El folio se guarda en el carrito ("Folio"). Código propio. */
(function () {
  if (window.PVCot) return;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/', HDR = { 'Content-Type': 'application/json', 'Accept': 'application/json' }, NUEVO = null;
  function enc(o) { return btoa(unescape(encodeURIComponent(JSON.stringify(o)))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); }
  function id6() { var a = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789', s = ''; for (var i = 0; i < 6; i++) s += a[Math.floor(Math.random() * a.length)]; return s; }
  function hoy() { var d = new Date(); return +(d.getFullYear() + ('0' + (d.getMonth() + 1)).slice(-2) + ('0' + d.getDate()).slice(-2)); }
  function n(s) { return parseInt(String(s || ''), 10) || 0; }
  function m2(v) { return '$' + (+v).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function linea(it) {
    var p = it.properties || {}, A = n(p['_Ancho (cm)']), L = n(p['_Largo (cm)']);
    if (!A || !L) { var m = String(p['Medida'] || '').match(/(\d+)\s*[×x]\s*(\d+)/); if (m) { A = +m[1]; L = +m[2]; } }
    return [A, L, n(p['Calibre']) || 400, n(p['Perforaciones']), /^con/i.test(p['Fuelle'] || '') ? 1 : 0, /^con/i.test(p['Fondo'] || '') ? 1 : 0, it.quantity];
  }
  function envio(a) { try { return a['_EnvioSel'] ? JSON.parse(a['_EnvioSel']) : null; } catch (e) { return null; } }
  /* c = objeto de /cart.js → { folio, link, pdf, kg, bultos, total, envio, envioSuma, lineas, resumen } */
  function desde(c) {
    var a = c.attributes || {}, folio = String(a['Cotización'] || a['Folio'] || '').replace(/^COT-/, '');
    var L = (c.items || []).filter(function (it) { return it.properties && it.properties['Medida']; }).map(linea);
    if (!folio) {
      folio = NUEVO || (NUEVO = id6());
      if (L.length) fetch(ROOT + 'cart/update.js', { method: 'POST', headers: HDR, body: JSON.stringify({ attributes: { 'Folio': 'COT-' + folio } }) }).catch(function () {});
    }
    var uvOn = (c.items || []).some(function (it) { return it.handle === 'aditivo-uv'; });
    var sel = envio(a), em = 0, etx = '';
    if (sel) { em = { 'tg-domicilio': 4, 'tg-ocurre': 5, 'sepomex': 6, 'particular': 1, 'planta': 2 }[sel.modo] || 0; if (sel.modo === 'tg-ocurre') etx = sel.sucursal || ''; }
    var Q = [folio, a['Cliente'] || '', a['Asesor'] || '', a['Factura'] === 'Sí' ? 1 : 0, String(a['CP'] || (sel && sel.cp) || ''), 0, 'i', 0, em, 0, etx, L, a['Condiciones adicionales'] || '', hoy(), '', uvOn ? 1 : 0];
    var link = location.origin + ROOT + (window.PVQ ? 'c#' + PVQ.pack(Q) : 'pages/cotizacion#q=' + enc(Q)), b = L.reduce(function (s, l) { return s + l[6]; }, 0);
    var suma = sel && (sel.modo === 'particular' || sel.modo === 'sepomex') && +sel.costo ? +sel.costo : 0, total = c.total_price / 100;
    var resumen = (c.items || []).filter(function (it) { return it.handle !== 'aditivo-uv'; }).map(function (it) { var p = it.properties || {}; return '• ' + (p['Medida'] || it.product_title) + (p['Calibre'] ? ', cal. ' + p['Calibre'] : '') + ': ' + it.quantity + ' bulto' + (it.quantity > 1 ? 's' : ''); }).join('\n')
      + (uvOn ? '\n• Aditivo contra rayos UV en todo el pedido' : '')
      + '\nTotal: ' + m2(total + suma) + (suma ? ' (con envío)' : '');
    return { folio: 'COT-' + folio, link: link, pdf: link + '&pdf', kg: b * 25, bultos: b, total: total, envio: sel, envioSuma: suma, lineas: L, resumen: resumen };
  }
  function cargar() { return fetch(ROOT + 'cart.js', { headers: HDR, credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(desde); }
  /* Mensaje de WhatsApp con el pedido y su cotización. Desde 1,000 kg: pide el proceso de pago. */
  function mensaje(k) {
    if (k.kg >= 1000) return 'Hola, estoy interesado en este pedido (' + k.folio + '). ¿Me podrían explicar el proceso para el pago?\n\n' + k.resumen + '\n\nMi cotización: ' + k.link;
    return 'Hola, tengo una duda con mi pedido de la página (' + k.folio + '):\n\n' + k.resumen + '\n\nMi cotización: ' + k.link;
  }
  window.PVCot = { desde: desde, cargar: cargar, mensaje: mensaje, m2: m2 };
})();
